// extracted by mini-css-extract-plugin
module.exports = {"label":"InputLabel_label__1nQGH","labelWrapper":"InputLabel_labelWrapper__1Ixfq","history-indication":"InputLabel_history-indication__2t_NG"};